module.exports = __webpack_public_path__ + "static/media/feature1.88305bc4.png";